import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["EmailSelectionCell"]

  get truckload_rates_table_controller() {
    return document.querySelector(`[data-controller="truckload-rates-table"]`)[`truckload-rates-table`]
  }

  connect() {
    this.truckload_rates_table_controller.determineShowCheckboxes()
  }

}